import React, { useState, ChangeEvent } from 'react'
import { useDispatch } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { useSelector } from 'react-redux';
import { useStartConversationMutation } from '../../store/services/genieservice';
import { useClassifyMutation } from '../../store/services/dataservice';
import { selectUserId } from '../../store/features/authSlice';
// import { useGeniePolling } from '../../hooks/useGeniePolling';
import Snackbar from '@mui/material/Snackbar';
import {
  // selectConversationPayload,
  setFirstAttachment,
  selectIsConversationOpen,
  setConversationPayload,
  setPreviousAttachmentId,
  setFollowup,
  // clearResults
} from '../../store/features/genieSlice';
import GenieExportButton from './GenieExportButton';
import GenieLogDialog from './GenieLogDialog';
import SpeechButton from '../common/SpeechButton';
import { setQuestion } from '../../store/features/genieSlice';
// import { selectIdToken } from '../../store/features/authSlice';

const GenieConversation = () => {
  const dispatch = useDispatch();
  // const conversationPayload = useSelector(selectConversationPayload)
  const [value, setValue] = useState<string | null>('');
  // const [open, setOpen] = useState(true);
  const [clearTranscriptFn, setClearTranscriptFn] = useState<(() => void) | null>(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  // const [noWorkspaceSnackbarOpen, setNoWorkspaceSnackbarOpen] = useState(false)
  const [startConversation] = useStartConversationMutation();
  const [classify] = useClassifyMutation();
  const isConversationOpen = useSelector(selectIsConversationOpen)
  const email = useSelector(selectUserId);

  // Use custom hook for polling logic
  // const { pollingInterval, setPollingInterval } = useGeniePolling();

  const handleToggle = () => {
    window.open("/genie", "_blank");
    return
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const newValue = event.target.value;
    setValue(newValue);
    
    // Clear transcript when user manually clears the input
    if (!newValue && clearTranscriptFn) {
      clearTranscriptFn();
    }
  }

  const handleQuestionSelect = (selectedQuestion: string) => {
    setValue(selectedQuestion);
  };

  const handleKeyDown = async (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();

      if (!value) return;
      
      // Clear any previous state
      dispatch(setFollowup(null))
      dispatch(setPreviousAttachmentId(''))
      dispatch(setConversationPayload(undefined))
      dispatch(setFirstAttachment(null));
      dispatch(setQuestion(''));
      // setPollingInterval(null);

      // First, call classify to get workspace_id
      try {
        const classifyResponse = await classify({ query: value, email }).unwrap();
        
        // Check if classifyResponse exists and has a valid workspace_id
        if (classifyResponse && classifyResponse.workspace_id && 
            classifyResponse.workspace_id.trim() !== '') {
          
          // Start conversation with workspace_id
          try {
            const response = await startConversation({ 
              content: value
            }).unwrap();

            if (response && response.conversation_id && response.message_id) {
              // Only set question after successful conversation start
              dispatch(setQuestion(value));
            }
          } catch (error: any) {
            console.error("Error in startConversation:", error);
          }
        } else {
          // setNoWorkspaceSnackbarOpen(true);
        }
      } catch (error: any) {
        console.error("Error in classify:", error);
        // Show error toast for API failures
        // setNoWorkspaceSnackbarOpen(true);
      }
    }
  }

  const handleSpeechResult = (text: string) => {
    setValue(text);
  };

  const handleSpeechPartialResult = (text: string) => {
    setValue(text);
  };

  // Add a function to clear the input when starting speech
  const handleStartListening = () => {
    setValue(''); // Clear the input field
  };

  // Handle setting the clearTranscript function from SpeechButton
  const handleClearTranscript = (clearTranscript: () => void) => {
    setClearTranscriptFn(() => clearTranscript);
  };

  return (
    <React.Fragment>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <GenieExportButton />
        <Button variant="outlined" onClick={handleToggle}>
          New Conversation
        </Button>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        message="Please create a conversation"
      />
      <Dialog open={isConversationOpen} fullWidth>
        <DialogTitle>New Conversation</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={1}>
              <GenieLogDialog onQuestionSelect={handleQuestionSelect} />
            </Grid>
            <Grid item xs={10}>
              <TextField
                fullWidth
                label="Genie - Ask something about data" 
                variant="outlined"
                value={value} 
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                autoComplete="off"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SpeechButton
                        onResult={handleSpeechResult}
                        onPartialResult={handleSpeechPartialResult}
                        onStartListening={handleStartListening}
                        onClearTranscript={handleClearTranscript}
                        size="small"
                      />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  )

}

export default GenieConversation